import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import BlogGrid from "./blog-components/blog-grid";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { withAppData } from "../app/withAppData";

class BlogGridPage extends Component {
  render() {
    const { blog, loading, lang, pageConfig } = this.props.appData;
    const blogConfig = pageConfig?.blog?.settings?.translations?.[lang] || {};
    const blogImg = pageConfig?.blog?.settings?.cover;

    return (
      <div>
        <Navbar />
        <PageHeader
          lang={lang}
          Img={blogImg}
          headertitle={blogConfig.title || "Blog"}
          subheader={blogConfig.title || "Blog"}
        />
        <BlogGrid lang={lang} blog={blog} loading={loading} />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default withAppData(BlogGridPage);
